import React from 'react';

const About = () => {
  return (
    <div>
      <h2 style={{ marginTop: 0, color: '#333' }}>Over mij</h2>
     <p style={{ lineHeight: '1.8', color: '#555' }}>
        Ik ben een enthousiaste developer met een groot doorzettingsvermogen. Met mijn
        sterke focus en creativiteit los ik complexe issues op. Ik vind het belangrijk om
        grote problemen simpel te maken om betere kwaliteit te leveren. In alles wat ik
        onderneem, streef ik ernaar mijn best te doen en mezelf continu te verbeteren.
      </p>
      {/* <p style={{ lineHeight: '1.8', color: '#555' }}>
        Tijdens mijn opleiding heb ik gewerkt met Java en React en ik wil mij bij mijn
        volgende rol verder ontwikkelen richting fullstack development. Ik werk graag in
        Agile/DevOps-teams en lever betrouwbare, onderhoudbare oplossingen.
      </p> */}
      <p style={{ lineHeight: '1.8', color: '#555' }}>
        Ik ben een rustige en vriendelijke persoon en ik vind betrokkenheid binnen
        het team belangrijk. Natuurlijk is het ook leuk om naast werk samen leuke
        dingen te doen, zoals een potje voetballen.
      </p>
    </div>
  );
};

export default About;